<template>
  <div class="about">
    <div class="oneCon">
      <img src="../assets/banner3.png" alt="">
    </div>
    <div class="twoCon">
      <div class="widthCon">
        <div class="title">星元集团</div>
      <div class="content">
        <p>星元集团，成立于2024年4月，是由加拿大企业ALPHASTAR GLOBAL HOLDINGS CORP投资成立的，包括上海温杜颂莱科技有限公司、上海萃达科技有限公司等旗下企业共同组成的集团公司。集团创始团队拥有超过30年在汽贸、房地产开发、零售业、酒店经营、金融服务和互联网行业的丰富经验，并在此基础上启动了星元计划。</p>
        <p>星元计划的核心目标是以公益为主，盈利为辅，旨在成为国内具有影响力的社会公益企业。该计划致力于优化生产和消费市场环境，提升中小企业的核心商业文化，并期望这种文化能够影响所有业者和消费者，使之成为品牌的核心力量。通过购买我们的产品或服务，消费者能够感受到自己为中国社会做出了贡献。星元集团凭借国内外的优质资源，致力于构建一个有利于国家和人民的商业环境。并与众多业者一起共同推动中国经济的增长和社会的进步。</p>
      </div>
      </div>
    </div>
    <div class="threeCon">
      <div class="title">企业文化</div>
      <div class="info">走正道、阳光下、合法、开心的工作和生活</div>
      <div class="listCon">
        <div class="list">
          <div class="sign">走正道</div>
          <div class="textCon">维护公平竞争，传播正能量，反对任何形式的欺诈和不正当手段</div>
        </div>
        <div class="list">
          <div class="sign">阳光下</div>
          <div class="textCon">坚持透明度和开放性，往来坦诚、信用立身</div>
        </div>
        <div class="list">
          <div class="sign">合法</div>
          <div class="textCon">遵守法律法规，确保所有业务活动都在法律框架内进行</div>
        </div>
        <div class="list">
          <div class="sign">开心</div>
          <div class="textCon">员工的幸福感和满意度是公司成功的关键，努力创造一个快乐、和谐的工作环境</div>
        </div>
      </div>
    </div>
    <div class="fourCon">
      <div class="title">我们的团队</div>
      <div class="content">
        <div class="leftCon">
          <div class="content_title"><div class="titleBorder"></div>团队背景</div>
          <div class="content_text">
            <p>自1994年起，创始团队创新性地推出了中国首个卡车分期付款服务模式，为运输个体户提供专业的卡车金融服务。经过15年的不懈努力，星元单业务网络曾遍布全国除港澳台外的所有省份，服务网点超过550家，确立了其作为全国最大卡车金融服务商的地位。累计业务成交量达到6万辆。2009年，公司成功以AUTOCHINA的名义在美国纳斯达克交易所上市。</p>
            <p>团队还投资建设了河北省首个钢结构建筑群—北国先天下广场、50万平米精装修住宅项目—剑桥春雨，以及河北首个超高层钢结构综合体。2013年，团队开发的53层245米的地标性建筑石家庄希尔顿酒店开业。石家庄希尔顿共有客房594间，是中国希尔顿酒店中客房数量最多的酒店之一。</p>
            <p>2008年，创始人李勇会与香港利福集团（SOGO久光百货）合作，成为河北商业龙头—北人集团的三大股东之一。截至2023年12月底，北人集团资产总额达到137.9亿元，经营面积超过200万平方米，经营网点超过300个。2023年，集团实现销售总额265亿元，位列中国零售百强第31位，中国连锁百强第29位。</p>
          </div>
        </div>
        <div class="rightCon">
          <img src="../assets/aboutImg1.png" alt="">
        </div>
      </div>
    </div>
    <div class="fiveCon commonCon">
      <div class="title">管理团队</div>
      <div class="content">
        <div class="textCon" style="margin-right: 40px">
          <div class="text_title">
            <img src="../assets/leftIcon.png" alt="">
            李勇会 | 创始人
          </div>
          <div class="text_info">
            <p>星元集团创始人李勇会先生是一位充满激情的连续创业者，他分别于2007年7月和1998年11月创立了开元金融和河北开元房地产开发股份有限公司（“河北开元”）。</p>
            <p>在2001年至2006年期间，李先生领导河北开元成功开发了河北省当时最大的钢结构建设项目——先天下广场，该项目包括住宅综合体、办公楼和一个高端购物中心，总面积超过一百万平方英尺。随后，在2013年，河北开元完成了245米高的开元金融中心的建设，这是一个集办公空间和五星级希尔顿酒店于一体的多用途建筑。</p>
            <p>李先生的创业之路始于1994年9月，当时他开创了中国的卡车租赁业务，并成立了石家庄高新技术产业开发区开元汽车贸易有限公司，这标志着开元金融互联网金融业务的雏形。</p>
            <p>李先生于1985年毕业于天津大学，并获得了光学物理学学士学位</p>
          </div>
        </div>
        <div class="textCon">
          <div class="text_title">
            <img src="../assets/leftIcon.png" alt="">
            李昂 | 执行董事
          </div>
          <div class="text_info">
            <p>李昂先生担任执行董事，并负责星元计划的战略执行。在此之前，他曾担任开元金融多个产品开发子公司的首席执行官，负责互联网项目的产品规划和开发。</p>
            <p>在加入星元集团之前，李先生曾担任亚马逊云计算中国（AWS China）的初创生态团队的业务拓展经理，负责拓展高潜力的初创科技企业在亚马逊云计算平台上搭建新型的互联网业务。</p>
            <p>从2011年到2014年，李先生在纽约的Cogent Partners担任投资银行分析师。在Cogent工作期间，李先生进行了国际化私募基金的尽职调查，管理了二级市场交易流程，并代表美国公共养老金、大型区域银行、资产管理公司和其他金融机构参与了近20亿美元的私募交易。</p>
            <p>李先生于2011年从美国杜克大学毕业，获得了经济学学士和心理学学士学位</p>
          </div>
        </div>
      </div>
    </div>
    <div class="sixCon commonCon">
      <div class="title">顾问团队</div>
      <div class="content">
        <div class="textCon" style="margin-right: 40px">
          <div class="text_title">
            <img src="../assets/rightIcon.png" alt="">
            Jason Wang | 财务顾问
          </div>
          <div class="text_info">
            <p>Jason Wang（王）先生作为星元集团的财务顾问，主要为集团的资本市场运作提供咨询服务。王先生曾担任开元金融的首席财务官（CFO）。在2009年加入开元金融之前，王先生在私募股权管理集团（PEM）担任研究与分析总监，负责潜在投资分析、信贷和现金流分析以及估值。</p>
            <p>从2005年至2007年，王先生在QUALCOMM Inc.工作负责包括风险资本投资的所有阶段，从目标公司识别到投资组合管理。从2004年至2005年，王先生是Relational Advisors LLC的投资银行副总裁，专注于并购以及债务和股权融资。从2000年3月至2002年7月，王先生是24/7 Real Media Inc.的企划发展总监，这是一家全球数字营销公司。在此之前，王先生是Chase Securities Inc.全球并购集团的投资银行分析师。</p>
            <p>王先生于2004年从美国加州大学洛杉矶分校UCLA Anderson School of Management获得MBA学位，并于1998年从美国宾夕法尼亚大学沃顿商学院和工程与应用科学学院获得学士学位。</p>
          </div>
        </div>
        <div class="textCon">
          <div class="text_title">
            <img src="../assets/rightIcon.png" alt="">
            James Sha | 战略顾问
          </div>
          <div class="text_info">
            <p>James Sha（沙）作为星元集团的战略顾问，为星元计划带来了数十年的互联网软件经验。自2009年起，沙先生一直担任开元金融在美上市公司的董事会成员。</p>
            <p>在2005年至2007年期间，沙先生担任AppStream的首席执行官，这是一家专注于软件应用虚拟化的公司。1999年，沙先生担任中文互联网媒体先驱——新浪网的首席执行官。</p>
            <p>从1996年7月至1998年8月，沙先生担任Actra Business Systems的首席执行官，该公司是Netscape Communications 和GE Information Services（GEIS）的合资企业，为B2C和B2B电子商务市场提供下一代互联网商务应用解决方案。从1990年5月至1994年8月，沙先生在甲骨文公司（纳斯达克股票代码：ORCL）担任副总裁。</p>
            <p>沙先生拥有台湾大学电气工程学士学位、加州大学伯克利分校电子工程与计算机科学硕士学位以及圣克拉拉大学MBA学位。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = "星元计划-关于我们";
  }
}
</script>

<style lang="less" scoped>
.oneCon{
  position: relative;
  img{
    width: 100%;
  }
}
.twoCon{
  padding: 74px 0px 85px 0px;
  background: #E7F3FC;
  .widthCon{
    width: 1200px;
    margin: 0 auto;
  }
  .title{
    font-family: Source Han Sans;
    font-size: 30px;
    font-weight: bold;
    line-height: 48px;
    letter-spacing: normal;
    color: #222222;
    margin-bottom: 15px;
  }
  .content{
    p{
      text-indent: 2em;
      text-align: justify;
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 350;
      line-height: 34px;
      letter-spacing: normal;
      color: #666666;
      margin-bottom: 15px;
    }
  }
}
.threeCon{
  padding: 77px 0 85px 0;
  text-align: center;
  width: 1250px;
  margin: 0 auto;
  .title{
    font-family: Source Han Sans;
    font-size: 30px;
    font-weight: bold;
    line-height: 48px;
    text-align: center;
    letter-spacing: normal;
    color: #222222;
  }
  .info{
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: 350;
    line-height: 24px;
    text-align: center;
    letter-spacing: normal;
    color: #666666;
    margin-top: 18px;
  }
  .listCon{
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
    margin-top: 112px;
    .list{
      padding: 78px 28px 0px 28px;
      border-radius: 10px;
      background: #F3F8FF;
      position: relative;
      width: 246px;
      height: 190px;
      box-sizing: border-box;
      .sign{
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background: #4A90E2;
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: bold;
        line-height: 22px;
        text-align: center;
        letter-spacing: normal;
        color: #FFFFFF;
        line-height: 100px;
        text-align: center;
        position: absolute;
        top: -50px;
        left: calc(50% - 50px)
      }
      .textCon{
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: 350;
        line-height: 26px;
        text-align: center;
        letter-spacing: normal;
        color: #666666;

      }
    }
  }
}
.fourCon{
  background: #F9FAFB;
  padding-top: 77.5px;
  padding-bottom: 85.5px;
  .title{
    font-family: Source Han Sans;
    font-size: 30px;
    font-weight: bold;
    line-height: 48px;
    text-align: center;
    letter-spacing: normal;
    color: #222222;
    margin-bottom: 52px;
  }
  .content{
    border-radius: 10px;
    background: #FFFFFF;
    padding: 34px 25px 36px 25px;
    display: flex;
    width: 1200px;
    box-sizing: border-box;
    margin: 0 auto;
    justify-content: space-between;
    .leftCon{
      margin-right: 40px;
      flex: 1;
      .content_title{
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: bold;
        line-height: 24px;
        letter-spacing: normal;
        color: #222222;
        display: flex;
        align-items: center;
        .titleBorder{
          width: 5px;
          height: 20px;
          border-radius: 1px;
          background: #4A90E2;
          margin-right: 4px;
          display: inline-block;
        }
      }
      .content_text{
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 350;
        line-height: 34px;
        letter-spacing: normal;
        color: #666666;
        p{
          margin-top: 18px;
          text-indent: 2em;
text-align: justify;
        }
      }
    }
    .rightCon{
      flex: 0 0 500px;
      img{
        width: 500px;
        margin-top: 42px;
        height: 550px;
        border-radius: 10px;
      }
    }
  }
}
.fiveCon{
  background: #FFFFFF;
  .content{
    .textCon{
      background: #F3F8FF;
    }
  }
}
.sixCon{
  background: #F9FAFB;
  .content{
    .textCon{
      background: #fff;
    }
  }
}
.commonCon{
  padding-top: 77px;
  padding-bottom: 90px;
  .title{
    font-family: Source Han Sans;
    font-size: 30px;
    font-weight: bold;
    line-height: 48px;
    text-align: center;
    letter-spacing: normal;
    color: #222222;
    margin-bottom: 52px;
  }
  .content{
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
    .textCon{
      width: 600px;
      border-radius: 10px;
      padding: 34px 39px 42px 39px;
      box-sizing: border-box;
      .text_title{
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: bold;
        line-height: 24px;
        text-align: center;
        letter-spacing: normal;
        color: #222222;
        text-align: center;
        img{
          width: 47.5px;
          height: 47.5px;
          transform: translate(25px, 12px);
        }
      }
      .text_info{
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 350;
        line-height: 34px;
        letter-spacing: normal;
        color: #666666;
        text-indent: 2em;
text-align: justify;
        p{
          margin-top: 15px;
        }
      }
    }
  }
}
</style>
